import { api, useQuery, useRoleConf } from "@pharmupp/p3-front-commons"
import { useParams } from "react-router-dom"
import type { UserTypesName } from "../../referential"
import { UserForm } from "../UserForm"
import { apiRoleConf } from "../apiRoleConf"
import type { ApiUserModel } from "../models"
import { serverToForm } from "./userForm.adapter"

export const getUpdateUserQueryKey = (id?: string) => ["users", "form", id]

export const UpdateMyUser = () =>
  UpdateUser({ isReadOnly: (type) => type === "HOLDER" })

export const UpdateUser = ({
  isReadOnly,
}: {
  isReadOnly?: (type?: UserTypesName) => boolean
}) => {
  const { id } = useParams()

  const { resourceEndpoint } = useRoleConf(apiRoleConf)

  const { data: user, isLoading: loading } = useQuery({
    queryKey: getUpdateUserQueryKey(id),
    queryFn: () => api.get<ApiUserModel>(`${resourceEndpoint}/${id}`),
    select: serverToForm,
  })

  return (
    <UserForm
      defaultValues={{
        ...user,
        isUpdate: true,
        isReadOnly: isReadOnly?.(user?.type),
      }}
      loading={loading}
    />
  )
}
